module.exports = __webpack_public_path__ + "static/media/curie_logo.86c2cfa6.png";